import axios from 'axios'
import authHeader from './auth-header'

const resource = process.env.VUE_APP_API_URL + 'administrativo/unidades'

class UnidadesService {
  list (params = {}) {
    return axios.get(resource, { headers: authHeader(), params })
  }

  get (idUnidade) {
    return axios.get(`${resource}/${idUnidade}`, { headers: authHeader() })
  }

  getOptions () {
    return axios.get(`${resource}/opcoes`, { headers: authHeader() })
  }

  searchCities (params = {}) {
    return axios.get(`${resource}/cidades`, { headers: authHeader(), params })
  }

  create (data) {
    return axios.post(resource, data, { headers: authHeader() })
  }

  update (idUnidade, data) {
    return axios.put(`${resource}/${idUnidade}`, data, { headers: authHeader() })
  }

  integrateAgendaEdu (idUnidade) {
    return axios.post(`${resource}/${idUnidade}/agenda-edu`, {}, { headers: authHeader() })
  }

  getAgendaEduChannels (idUnidade) {
    return axios.get(`${resource}/${idUnidade}/agenda-edu/canais`, { headers: authHeader() })
  }

  updateAgendaEduChannels (idUnidade, canais) {
    return axios.put(`${resource}/${idUnidade}/agenda-edu/canais`, { canais }, { headers: authHeader() })
  }

  syncAgendaEduChannel (idUnidade, idCanalDefault) {
    return axios.post(`${resource}/${idUnidade}/agenda-edu/canais/${idCanalDefault}/sincronizar`, {}, { headers: authHeader() })
  }

  delete (idUnidade) {
    return axios.delete(`${resource}/${idUnidade}`, { headers: authHeader() })
  }
}

export default new UnidadesService()
